/* src/app/modules/subscription/reactivate-account-dialog/reactivate-account-dialog.component.css */
.reactivate-dialog-container {
  padding: 0;
  max-width: 580px;
}
.reactivate-dialog-content {
  padding: 32px 28px 28px;
  text-align: center;
  background:
    linear-gradient(
      135deg,
      #f0fdf4 0%,
      #ffffff 100%);
}
.reactivate-icon-wrapper {
  margin-bottom: 16px;
}
.reactivate-icon {
  font-size: 56px;
  line-height: 1;
  animation: celebrateAnimation 0.6s ease-out;
}
@keyframes celebrateAnimation {
  0% {
    opacity: 0;
    transform: scale(0.5) rotate(-10deg);
  }
  50% {
    transform: scale(1.1) rotate(5deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}
.reactivate-title {
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
}
.reactivate-subtitle {
  margin: 0 0 18px 0;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  line-height: 1.5;
}
.reactivate-benefits {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f0fdf4;
  border-radius: 10px;
  border: 1px solid #bbf7d0;
  text-align: left;
}
.benefits-title {
  margin: 0 0 14px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}
.benefit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #444444;
  font-size: 14px;
  line-height: 1.5;
}
.benefit-icon {
  color: #22c55e;
  font-weight: bold;
  flex-shrink: 0;
  font-size: 16px;
}
.reactivate-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}
.btn {
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-icon {
  font-size: 18px;
}
.btn-reactivate {
  background:
    linear-gradient(
      135deg,
      #22c55e,
      #16a34a);
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.35);
}
.btn-reactivate:hover {
  background:
    linear-gradient(
      135deg,
      #16a34a,
      #15803d);
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.45);
  transform: translateY(-2px);
}
.btn-reactivate:active {
  transform: translateY(0);
  box-shadow: 0 3px 12px rgba(34, 197, 94, 0.3);
}
.btn-cancel {
  background: transparent;
  border: 1px solid #d0d0d0;
  color: #666666;
  box-shadow: none;
}
.btn-cancel:hover {
  background-color: #fafafa;
  border-color: #b0b0b0;
  color: #444444;
}
.reactivate-footer {
  margin: 0;
  font-size: 13px;
  color: #888888;
  text-align: center;
}
.support-link {
  color: #22c55e;
  text-decoration: none;
  font-weight: 600;
}
.support-link:hover {
  text-decoration: underline;
}
@media (max-width: 500px) {
  .reactivate-dialog-container {
    min-width: 100%;
  }
  .reactivate-dialog-content {
    padding: 32px 24px 24px;
  }
  .reactivate-title {
    font-size: 22px;
  }
}
/*# sourceMappingURL=reactivate-account-dialog.component.css.map */
